import React from 'react';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { Box, Container, Icon, PageContent, Text } from 'bumbag';

function Canceled() {
  //////////////////////////////////////////
  return (
    <Container isFluid>
      <PageContent
        alignX="center"
        maxWidth="400px"
        wrapperProps={{
          backgroundColor: 'white600',
          border: 'none',
        }}
      >
        {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
        <Icon icon={faExclamationTriangle} type="font-awesome" fontSize="200px" marginRight="major-1" color="warning" />
        <Box marginTop="major-2">
          <Text fontSize="1.4rem">Your request has been canceled.</Text>
        </Box>
      </PageContent>
    </Container>
  );
}

export default Canceled;
